import { useEffect, useMemo, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { track } from "./../lib/gtag.js";
import { TAB_EVENTS } from "./../lib/gtagService.js";
const useTabItems = ({ tabItems }) => {
  var _a, _b;
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTabKey, setActiveTabKey] = useState(
    ((_a = tabItems.find((item) => item.isSelected && item.visible)) == null ? void 0 : _a.key) || ((_b = tabItems[0]) == null ? void 0 : _b.key)
  );
  const [tabsActiveTabId, setTabsActiveTabId] = useState(null);
  const activeTabKeyByUrl = useMemo(
    () => searchParams.get("t"),
    [searchParams]
  );
  const tabsActiveTabIdByUrl = useMemo(
    () => searchParams.get("st"),
    [searchParams]
  );
  const activeTabData = useMemo(() => {
    const relatedData = tabItems == null ? void 0 : tabItems.find((item) => item.key === activeTabKey);
    if ((relatedData == null ? void 0 : relatedData.metadata.items) && (relatedData == null ? void 0 : relatedData.metadata.items.length) > 1 && ["Results", "Fixtures", "PlayerMatches"].includes(activeTabKey) && !(relatedData == null ? void 0 : relatedData.metadata.items.find(
      (item) => ["All", "Regular Season"].includes(item.name)
    ))) {
      relatedData.metadata.items = [
        { id: "", name: "All" },
        ...relatedData.metadata.items
      ];
    }
    return relatedData;
  }, [tabItems, activeTabKey]);
  const tabsTabItems = useMemo(
    () => {
      var _a2;
      return (_a2 = activeTabData == null ? void 0 : activeTabData.metadata.items) != null ? _a2 : [];
    },
    [activeTabData == null ? void 0 : activeTabData.metadata.items]
  );
  const items = useMemo(
    () => tabItems.filter((item) => item.visible).map((item) => ({
      key: item.key,
      label: item.displayName
    })),
    [tabItems]
  );
  useEffect(() => {
    var _a2, _b2, _c, _d;
    const activeTabByUrl = tabItems.find(
      (item) => item.key === activeTabKeyByUrl
    );
    const activeTabKey2 = (activeTabByUrl == null ? void 0 : activeTabByUrl.key) || ((_a2 = tabItems.find((item) => item.isSelected && item.visible)) == null ? void 0 : _a2.key) || ((_b2 = tabItems[0]) == null ? void 0 : _b2.key);
    const activeTabData2 = tabItems == null ? void 0 : tabItems.find(
      (item) => item.key === activeTabKey2
    );
    const tabsTabItems2 = (_c = activeTabData2 == null ? void 0 : activeTabData2.metadata.items) != null ? _c : [];
    setActiveTabKey(activeTabKey2);
    setTabsActiveTabId((_d = tabsTabItems2[0]) == null ? void 0 : _d.id);
    if (!activeTabByUrl && tabsTabItems2.length > 0) {
      const next = new URLSearchParams(searchParams);
      next.delete("t");
      setSearchParams(next, { replace: true });
    }
  }, [tabItems, activeTabKeyByUrl]);
  useEffect(() => {
    var _a2;
    const found = tabsTabItems == null ? void 0 : tabsTabItems.find((i) => i.id === +tabsActiveTabIdByUrl);
    setTabsActiveTabId((found == null ? void 0 : found.id) || ((_a2 = tabsTabItems[0]) == null ? void 0 : _a2.id));
  }, [tabsTabItems, tabsActiveTabIdByUrl]);
  useEffect(() => {
    var _a2;
    const mappedPathname = pathname ? pathname.split("/")[1] : null;
    if (activeTabKey && mappedPathname && ((_a2 = TAB_EVENTS[mappedPathname]) == null ? void 0 : _a2[activeTabKey])) {
      track(TAB_EVENTS[mappedPathname][activeTabKey]);
    }
  }, [activeTabKey, pathname]);
  const handleSetActiveTabKey = (activeTabKey2) => {
    var _a2, _b2;
    const activeTabData2 = tabItems == null ? void 0 : tabItems.find(
      (item) => item.key === activeTabKey2
    );
    const tabsTabItems2 = (_a2 = activeTabData2 == null ? void 0 : activeTabData2.metadata.items) != null ? _a2 : [];
    setActiveTabKey(activeTabKey2);
    setTabsActiveTabId((_b2 = tabsTabItems2[0]) == null ? void 0 : _b2.id);
    const next = new URLSearchParams(searchParams);
    next.set("t", activeTabKey2);
    next.delete("st");
    setSearchParams(next);
  };
  const handleSetTabsActiveTabId = (tabId) => {
    setTabsActiveTabId(tabId);
    const next = new URLSearchParams(searchParams);
    tabId ? next.set("st", tabId) : next.delete("st");
    setSearchParams(next);
  };
  return {
    items,
    activeTabKey,
    activeTabData,
    tabsActiveTabId,
    setTabsActiveTabId: handleSetTabsActiveTabId,
    setActiveTabKey: handleSetActiveTabKey
  };
};
var stdin_default = useTabItems;
export {
  stdin_default as default
};
